import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';

import { Permissions } from '@efficiently/models';

import { PAGES_ROUTES } from '@efficiently/client-core-routing';
import { GetOrgAccount } from '@efficiently/client-domain-org-admin';
import { PermissionSelectors } from '@efficiently/client-domain-permissions';
import { EffIconComponent } from '@efficiently/client-ui-icons';

import { DesignAssistantComponent } from './design-assistant/design-assistant.component';

@Component({
	selector: 'ds-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [EffIconComponent, RouterLink, DesignAssistantComponent],
})
export class HeaderComponent implements OnInit {
	private readonly store = inject(Store);

	protected hasAIAssistantPermission: boolean = false;
	protected readonly rootRoute = PAGES_ROUTES.ROOT.fullPath();

	public ngOnInit(): void {
		this.store.dispatch(new GetOrgAccount());
		this.hasAIAssistantPermission = this.store.selectSnapshot(
			PermissionSelectors.hasPermission(Permissions.AIAssistant),
		);
	}
}
